import block from "bem-css-modules";
import s from './ProgressBar.module.scss';
import {useEffect, useState} from "react";

const b = block(s);

const ProgressBar = (props) => {
    let {
        size = 150,
        trackWidth = 10,
        trackColor = `#ddd`,
        indicatorWidth = 10,
        indicatorColor = `#07c`,
        indicatorCap = `round`,
        label = `Loading...`,
        labelColor = `#333`,
        spinnerMode = false,
        spinnerSpeed = 1
    } = props

    const loadingDuration = 3000
    const [progress, setProgress] = useState(0)

    useEffect(() => {
        let loadingTimeout = setTimeout(() => {
            if (progress >= 100) setProgress(0)
            setProgress(progress + 1)
        }, loadingDuration/100)

        return () => {
            clearTimeout(loadingTimeout)
        }
    }, [progress])

    const center = size / 2,
        radius = center - (trackWidth > indicatorWidth ? trackWidth : indicatorWidth),
        dashArray = 2 * Math.PI * radius,
        dashOffset = dashArray * ((100 - progress) / 100)

    let hideLabel = (size < 100 || !label.length || spinnerMode)

    return (
        <>
            <div
                className={b("wrapper")}
                style={{width: size, height: size}}
            >
                <svg
                    className={b()}
                    style={{width: size, height: size}}
                >
                    <circle
                        className={b("track")}
                        cx={center}
                        cy={center}
                        fill="transparent"
                        r={radius}
                        stroke={trackColor}
                        strokeWidth={trackWidth}
                    />
                    <circle
                        className={b('indicator', {spinner: spinnerMode})}
                        style={{animationDuration: spinnerSpeed * 1000}}
                        cx={center}
                        cy={center}
                        fill="transparent"
                        r={radius}
                        stroke={indicatorColor}
                        strokeWidth={indicatorWidth}
                        strokeDasharray={dashArray}
                        strokeDashoffset={dashOffset}
                        strokeLinecap={indicatorCap}
                    />
                </svg>

                {!hideLabel && (
                    <div
                        className={b("label")}
                        style={{color: labelColor}}
                    >
            <span className={b("label",{loading:true})}>
              {label}
            </span>

                        {!spinnerMode && (
                            <span className={b("label",{progress:true})}>
                {`${
                    progress > 100 ? 100 : progress
                }%`}
              </span>
                        )}
                    </div>
                )}
            </div>
        </>
    )
}

export default ProgressBar